const SESSION_COOKIE = 'umsSessionToken'
const POLL_INTERVAL  = 3000  // check every 3 seconds

export function initSessionSync(onLogout) {
  let lastValue = getCookie(SESSION_COOKIE)

  const interval = setInterval(() => {
    const current = getCookie(SESSION_COOKIE)

    if (lastValue && !current) {
      // Cookie disappeared — user logged out from another subdomain
      clearInterval(interval)
      onLogout()
    }

    lastValue = current
  }, POLL_INTERVAL)

  return () => clearInterval(interval)  // cleanup function
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? match[2] : null
}